import { Dispatch } from 'react';
import { get, put, remove } from 'communication/httpClient';
import {
  SET_TOUCHPOINTDISPLAY_LIST,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
  CREATE_INITIATED,
  UPDATE_INITIATED,
  DELETE_INITIATED,
  TOUCHPOINTDISPLAY_DELETED,
  TOUCHPOINTDISPLAY_CREATED,
  TOUCHPOINTDISPLAY_UPDATED,
  CLEAN_TOUCHPOINTDISPLAY,
  SET_TOUCHPOINTDISPLAY
} from './actionTypes';
import { ITouchpointDisplay, ITouchpointDisplaysAction, ITouchpointDisplaysActions } from './types';

export const initialActionsState = {
  loadTouchpointDisplays: () => {},
  loadTouchpointDisplay: () => {},
  saveTouchpointDisplay: () => {},
  deleteTouchpointDisplay: () => {},
  cleanTouchpointDisplay: () => {}
};

export const getActions = (
  dispatch: Dispatch<ITouchpointDisplaysAction>
): ITouchpointDisplaysActions => ({
  loadTouchpointDisplays: async () => {
    dispatch({
      type: SYNC_INITIATED
    });
    const { data, error } = await get(`/api/touchpoint-display`);

    if (data) {
      dispatch({
        type: SET_TOUCHPOINTDISPLAY_LIST,
        payload: data
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error
      });
    }
    dispatch({
      type: SYNC_FINISHED
    });
  },
  loadTouchpointDisplay: async (id: string) => {
    dispatch({
      type: SYNC_INITIATED
    });
    const { data, error } = await get(`/api/touchpoint-display/${id}`);

    if (data) {
      dispatch({
        type: SET_TOUCHPOINTDISPLAY,
        payload: data
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error
      });
    }
    dispatch({
      type: SYNC_FINISHED
    });
  },
  saveTouchpointDisplay: async (touchpointDisplay: ITouchpointDisplay, isNew: boolean, callback) => {
    dispatch({
      type:SYNC_INITIATED
    });
    dispatch({
      type: isNew ? CREATE_INITIATED : UPDATE_INITIATED
    });
    const formData = new FormData();
    formData.append('touchpointDisplayData', JSON.stringify(touchpointDisplay));

    if (touchpointDisplay.logoFile) {
      formData.append('logoFile', touchpointDisplay.logoFile);
    }

    const url = `/api/touchpoint-display/${touchpointDisplay.displayId}`;
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };
    const { data, error } = await put(url, formData, config);

    if (error) {
      dispatch({
        type: SYNC_FAILED,
        payload: error
      });
    } else {
      dispatch({ type: CLEAN_TOUCHPOINTDISPLAY });
      dispatch({
        type: isNew ? TOUCHPOINTDISPLAY_CREATED : TOUCHPOINTDISPLAY_UPDATED,
        payload: data
      });
      if (callback) {
        callback();
      }
    }
    dispatch({
      type: SYNC_FINISHED
    });
  },
  deleteTouchpointDisplay: async (id: string, callback?: () => void) => {
    dispatch({
      type: DELETE_INITIATED
    });
    const { data, error } = await remove(`/api/touchpoint-display/${id}`);

    if (data || data === '') {
      dispatch({
        type: TOUCHPOINTDISPLAY_DELETED,
        payload: id
      });
      if (callback) {
        callback();
      }
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error
      });
    }
    dispatch({
      type: SYNC_FINISHED
    });
  },
  cleanTouchpointDisplay: () => {
    dispatch({
      type: CLEAN_TOUCHPOINTDISPLAY
    });
  }
});
